import { format } from 'date-fns'
import { Link, useParams } from 'react-router-dom'
import { useArpMedia } from '../../../queries/arpMedia'
import { useSamplePack } from '../../../queries/samplePacks'
import Button from '../../core/Button/Button'
import CenteredLoadingAnimation from '../../core/CenteredLoadingAnimation'
import { Box, Spacer } from '../../core/Components'
import { Flex } from '../../core/Flex'
import Text from '../../core/Text/Text'
import { InternalEndpoint } from '../../Internal'
import { ArpMediaTableHeader } from '../../internal/arp'
import { UserDetails } from '../../internal/components/common'
import { SamplePackSoundsTable } from './components'

export const SamplePackDetails = () => {
  const params = useParams<{ id: string }>()
  const id = parseInt(params.id)
  const samplePackQuery = useSamplePack({ id })
  const coverArpMediaId = samplePackQuery.data?.coverArpMediaId
  const coverArpQuery = useArpMedia({
    id: coverArpMediaId,
    options: { enabled: !!coverArpMediaId }
  })

  const project = samplePackQuery.data?.project

  return (
    <>
      {samplePackQuery.isLoading && <CenteredLoadingAnimation />}
      {!samplePackQuery.isLoading && (
        <Flex direction="column" css={{ gap: '16px' }}>
          <Flex css={{ gap: '16px' }}>
            <Text size="24">{samplePackQuery.data.title}</Text>
            <Spacer />
            <Link to={`/${InternalEndpoint}/sample-packs/${samplePackQuery.data.id}/edit`}>
              <Button type="dark" big>
                Edit
              </Button>
            </Link>
          </Flex>
          <Box
            css={{
              aspectRatio: 3 / 2,
              borderRadius: '$8',
              marginTop: '8px',
              backgroundImage: `url(${samplePackQuery.data.coverImage.url})`,
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              maxWidth: '400px'
            }}
          ></Box>
          <Flex direction="column" css={{ gap: '16px' }}>
            <Text size="16">Description: {samplePackQuery.data.description}</Text>
          </Flex>
          {project && (
            <Flex direction="column" css={{ gap: '16px' }}>
              <Text size="16">Project name: {project.name}</Text>
              <Flex css={{ gap: '4px' }}>
                <Text size="16">Project URL:</Text>
                <Text size="16" css={{ color: '$blue05' }}>
                  <a href={project.url} target="_blank">
                    {project.url}
                  </a>
                </Text>
              </Flex>
            </Flex>
          )}
          {coverArpQuery?.data && (
            <Flex css={{ gap: '4px' }}>
              <Text size="16">Cover Arp Media: </Text>
              <Text size="16" css={{ color: '$blue05' }}>
                <Link to={`/${InternalEndpoint}/arp/${coverArpQuery.data.id}`}>
                  {coverArpQuery.data.metadata.title} ({coverArpQuery.data.id})
                </Link>
              </Text>
            </Flex>
          )}
          <Flex direction="column" css={{ gap: '16px' }}>
            <Text size="16">
              Created at: {format(new Date(samplePackQuery.data.createdAt), 'MM/dd/yyy')}
            </Text>
          </Flex>
          <Text size="20">User</Text>
          <UserDetails user={samplePackQuery.data.user} />
          <Text size="20">Sounds</Text>
          <Box>
            <ArpMediaTableHeader />
            <SamplePackSoundsTable samplePackId={id} />
          </Box>
        </Flex>
      )}
    </>
  )
}
